// @flow
import Input from './Input'
import { createFormGroup } from '@src/components/ui/FormGroup'

export default createFormGroup(Input)
